import { all } from 'redux-saga/effects';
import { loginSaga } from './login';
import { userSaga } from './user';
import { certificatesSaga } from './certificates';
import { gestionSaga } from './gestion';
import { registerSaga } from './register';
import { captchaSaga } from './captcha';
import { licenseSaga } from './license';
import { packagesSaga } from './packages';
import { paymentTransactionSaga } from './paymentTransaction';
import { taxpayerSaga } from './taxpayer';
import { statusServiceSaga } from './statusService';
import { notificationSaga } from './notification';
import { dashboardSaga } from './dashboard';
import { folderSaga } from './folder';
import { googleDriveSaga } from './googleDrive';
import { responseRateSaga } from './responseRate';

export default function* rootSaga() {	
	yield all([
		loginSaga(),
		userSaga(),
		certificatesSaga(),
		gestionSaga(),
		registerSaga(),
		captchaSaga(),
		licenseSaga(),
		packagesSaga(),
		paymentTransactionSaga(),
		taxpayerSaga(),
		statusServiceSaga(),
		notificationSaga(),
		dashboardSaga(),
		folderSaga(),
		googleDriveSaga(),
		responseRateSaga()
	]);
};